(() => {

const ACCORDION_ROWS_DURATION = 0.45;
const ACCORDION_ROWS_EASE = 'power2.inOut';

class AccordionRows extends HTMLElement {
  connectedCallback() {
    this.accordions = Array.from(this.querySelectorAll('[data-accordion]'));
    this.hasGsap = typeof gsap !== 'undefined';
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const element = this;

    this.accordions.forEach(function (accordion) {
      const toggle = accordion.querySelector('[data-accordion-toggle]');

      if (!toggle) {
        return;
      }

      toggle.addEventListener('click', function () {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        element.closeAll();

        if (!isOpen) {
          element.open(accordion);
        }
      });
    });
  }

  setIcon(accordion, isOpen) {
    const vertical = accordion.querySelector('[data-accordion-vertical]');

    if (!vertical) {
      return;
    }

    if (this.hasGsap && !this.reducedMotion) {
      gsap.killTweensOf(vertical);
      gsap.to(vertical, {
        scaleY: isOpen ? 0 : 1,
        opacity: isOpen ? 0 : 1,
        transformOrigin: 'center',
        duration: ACCORDION_ROWS_DURATION,
        ease: ACCORDION_ROWS_EASE,
      });
    } else {
      vertical.classList.toggle('hidden', isOpen);
    }
  }

  open(accordion) {
    const toggle = accordion.querySelector('[data-accordion-toggle]');
    const panel = accordion.querySelector('[data-accordion-panel]');

    if (!toggle || !panel) {
      return;
    }

    toggle.setAttribute('aria-expanded', 'true');
    panel.classList.remove('hidden');
    accordion.setAttribute('data-active', '');
    this.setAttribute('data-open', '');
    this.setIcon(accordion, true);

    if (!this.hasGsap || this.reducedMotion) {
      return;
    }

    gsap.killTweensOf(panel);
    gsap.fromTo(panel, { height: 0 }, { height: 'auto', duration: ACCORDION_ROWS_DURATION, ease: ACCORDION_ROWS_EASE });
  }

  closeAll() {
    const element = this;

    this.removeAttribute('data-open');

    this.accordions.forEach(function (accordion) {
      accordion.removeAttribute('data-active');

      const toggle = accordion.querySelector('[data-accordion-toggle]');
      const panel = accordion.querySelector('[data-accordion-panel]');

      if (!toggle || !panel) {
        return;
      }

      const wasOpen = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', 'false');
      element.setIcon(accordion, false);

      if (!wasOpen) {
        return;
      }

      if (!element.hasGsap || element.reducedMotion) {
        panel.classList.add('hidden');

        return;
      }

      gsap.killTweensOf(panel);
      gsap.to(panel, {
        height: 0,
        duration: ACCORDION_ROWS_DURATION,
        ease: ACCORDION_ROWS_EASE,
        onComplete: function () {
          panel.classList.add('hidden');
          panel.style.height = '';
        },
      });
    });
  }
}

if (!customElements.get('accordion-rows')) {
  customElements.define('accordion-rows', AccordionRows);
}

})();
